import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { handleGoogleCallback } from "services/auth.service";

export const AuthSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    handleGoogleCallback().then((res) => {
      if (res.success) {
        navigate("/websites");
      } else {
        console.error("Google callback error:", res.message);
        navigate(
          `/auth/error?message=${encodeURIComponent(
            res.message ?? "Error not found"
          )}`
        );
      }
    });
  }, [navigate]);

  return (
    <div className="flex items-center justify-center h-screen">
      <p className="text-xl text-gray-700">Signing you in...</p>
    </div>
  );
};
